/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer?: string;
};

type ReturnTuple = [
  vp.ACHWithdrawTransactionResponse | undefined,
  (requestParams?: vp.ACHWithdrawTransactionRequest) => void,
  () => void,
];

function useFetchACHWithdrawTransaction({ api, bearer }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.ACHWithdrawTransactionRequest>();
  const [response, setResponse] = useState<vp.ACHWithdrawTransactionResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ACHWithdrawTransactionRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen', true);

      const res = await api.fetchACHWithdrawTransaction(requestParams, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, '', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.ACHWithdrawTransactionRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchACHWithdrawTransaction);
